import styled from "styled-components";

import { BORDER_COLOR, MAIN_BORDER_COLOR } from "components/theme";

export const Workspace = styled.section`
  display: grid;
  gap: 24px;
  grid-template-columns: minmax(232px, 25%) minmax(0, 1fr);

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const DayPane = styled.aside`
  border-right: 1px solid #e0e0e0;
  min-width: 0;
  padding-bottom: 24px;
  padding-right: 16px;

  @media (max-width: 768px) {
    border-bottom: 1px solid #e0e0e0;
    border-right: 0;
    padding-bottom: 16px;
    padding-right: 0;
  }
`;

export const DetailPane = styled.main`
  min-width: 0;
`;

export const DetailHeader = styled.header`
  align-items: flex-start;
  display: flex;
  gap: 8px;
  justify-content: space-between;
  margin-bottom: 12px;

  .MuiTypography-body2 {
    color: #666;
  }
`;

export const EditorCard = styled.section`
  background-color: #fff;
  border: 1px solid ${MAIN_BORDER_COLOR};
  margin-bottom: 8px;
  padding: 20px;
`;

export const MonthBar = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const DayRow = styled.div`
  background-color: #fff;
  border: 1px solid ${BORDER_COLOR};
  border-radius: 3px;
  margin-bottom: 6px;
  position: relative;

  button[data-day-select] {
    color: inherit;
    display: block;
    padding: 5px 36px 5px 10px;
    text-align: left;
    text-transform: none;
    width: 100%;
  }

  .day-date {
    display: block;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.4;
  }

  .day-detail {
    color: #666;
    display: block;
    font-size: 12px;
    line-height: 1.4;
  }

  .day-add {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
  }

  &[data-selected="true"] {
    background-color: #ececec;
    border-left: 5px solid #000;
    border-radius: 0;
  }

  /* Compensa i 4px in più del bordo di selezione per non spostare il testo. */
  &[data-selected="true"] button[data-day-select] {
    padding-left: 6px;
  }

  &[data-weekend="true"] .day-date {
    color: #8a5b00;
  }
`;
